<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>

    <div class="bg-light py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="card border-0 shadow rounded-lg" data-aos="fade-up">
              <div class="card-body p-4 p-md-5">
                <!-- Spanish Version -->
                <section lang="es" id="spanish-version" aria-labelledby="spanish-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 class="text-primary font-weight-bold mb-1">Eliminación de Datos</h1>
                    
                  </div>

                  <div class="deletion-content">
                    <h2>Instrucciones para eliminar datos</h2>
                    <p>
                      Si desea eliminar los datos asociados con la aplicación de Total Realty, por favor contáctenos al correo
                      <a href="mailto:info@totalnica.com?subject=Solicitud de Eliminación de Datos" class="text-primary font-weight-bold">info@totalnica.com</a>
                      con el asunto "Solicitud de Eliminación de Datos." Procesaremos su solicitud dentro de 7 días hábiles y eliminaremos permanentemente toda la información relacionada con
                      su cuenta.
                    </p>
                  </div>
                </section>

                <!-- Divider between languages -->
                <div class="divider my-5" aria-hidden="true"></div>

                <!-- English Version -->
                <section lang="en" id="english-version" aria-labelledby="english-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 class="text-primary font-weight-bold mb-1">Data Deletion</h1>
                    
                  </div>

                  <div class="deletion-content">
                    <h2>Data Deletion Instructions</h2>
                    <p>
                      If you wish to delete your data associated with the Total Realty application, please contact us at
                      <a href="mailto:info@totalnica.com?subject=Data Deletion Request" class="text-primary font-weight-bold">info@totalnica.com</a>
                      with the subject line "Data Deletion Request." We will process your request within 7 business days and permanently remove all information related to your account.
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["NavSolid"],

  components: {},
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.deletion-content h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: var(--primary);
  font-weight: 600;
}

.deletion-content p {
  line-height: 1.7;
  margin-bottom: 1rem;
  color: var(--text);
}

.divider {
  border-top: 2px dashed var(--border);
}

section h1 {
  font-size: 1.75rem;
  color: var(--primary);
}
</style>
